import { text } from '../Dashboard/text.i18n';
import { validation } from '../Dashboard/validation.i18n';

export const appLanguage = { text, validation };
